export default "__VITE_ASSET__BjlzfU6n__"